import { connect } from 'react-redux';
import Notes from './Notes';
import { getCustomerNotes } from '../../appointmentSelector';
import { setCustomerNotes } from '../../actions';

const mapStateToProps = state => ({
  value: getCustomerNotes(state),
  title: 'Client notes',
});

const mapDispatchToProps = {
  onChange: setCustomerNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);

